var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHistoryOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "M14.969 16.95 10 13.87V7h2v5.762l4.031 2.488zM22 12c0 5.512-4.488 10-10 10S2 17.512 2 12h1c0 4.96 4.04 9 9 9s9-4.04 9-9-4.04-9-9-9a8.932 8.932 0 0 0-7.719 4.379c-.11.18-.222.371-.312.562-.008.02-.02.04-.028.059H8v1H1.96V3h1v4.738c.04-.09.071-.168.11-.25.11-.218.23-.418.352-.629C5.219 3.86 8.512 2 12 2c5.512 0 10 4.488 10 10zm0 0"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryOutline);
export default __webpack_public_path__ + "static/media/history_outline.c90f15491cb575fd9f165a58fbd8b3ce.svg";
export { ForwardRef as ReactComponent };